module.exports = Em.Handlebars.compile("<modal-module\n    {{bind-attr variant=modalVariant}}\n    {{bind-attr organizationId=organization.id}}\n/>\n");